import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getAssignmentsByTarget,
  createAssignment,
  deleteAssignment,
} from "@/lib/forms-api";
import { useOrgId } from "@/lib/org-context";

export function useFormAssignments(
  assignableType: "project" | "task",
  assignableId: string | undefined
) {
  const qc = useQueryClient();
  const orgId = useOrgId();
  const queryKey = ["form-assignments", orgId, assignableType, assignableId];

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => getAssignmentsByTarget(assignableType, assignableId!),
    enabled: !!orgId && !!assignableId,
  });

  const add = useMutation({
    mutationFn: (formId: string) =>
      createAssignment(formId, { assignableType, assignableId: assignableId! }),
    onSuccess: () => qc.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: ({ formId, assignmentId }: { formId: string; assignmentId: string }) =>
      deleteAssignment(formId, assignmentId),
    onSuccess: () => qc.invalidateQueries({ queryKey }),
  });

  return {
    assignments: data?.assignments ?? [],
    loading: isLoading,
    add,
    remove,
  };
}
